import "./styles.css";
interface CardProps {
  text: string;
}

export const QuestionText = ({ text }: CardProps) => {
  return <p className="questionText">{text}</p>;
};
